import type { FaireProductEntity } from "../../entity_types/product";

export const p_t399k5f8yj: FaireProductEntity = {
  token: "p_t399k5f8yj",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Neptune (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/2ec1e781b7afcee8d2cabc6abbba8a5223dd9351aa70d89666d719ef4e7941be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d6fb531709171e3abf9f86cc43ee8e4e9f1ec92b987af261247ea14ae737804.jpeg",
    "https://cdn.faire.com/fastly/07cf5c5959d1be899d2a55d24bb8bef0514ea3bdbad25b06152a64a3dacd9f39.jpeg",
    "https://cdn.faire.com/fastly/98ae271da47f54cd24d068f4dafb73bed191e9fb8afff6e4a8f187307887473f.jpeg",
    "https://cdn.faire.com/fastly/df5d2bd9ef7739f910c6242eaf816c7b5a18a208d9c01ba67b4399f23ae4b24a.jpeg",
    "https://cdn.faire.com/fastly/774a71c645c5075cff664936d13477a354a28241d4827b95751516bcc3fb8e8a.jpeg",
    "https://cdn.faire.com/fastly/3b837c8e8f45eecc87d09a0b90fc4d2c55ee27555f463e3d773381edb9115f7c.jpeg",
    "https://cdn.faire.com/fastly/5a98d67f34d597a63a767cd0e4781445854ea0528e3efb01e681d9c5fc9700e6.jpeg",
    "https://cdn.faire.com/fastly/0ae740b87cef8ca19e68417af10fffa479c0ad5496b462a2ffbd832a15d837ad.jpeg",
    "https://cdn.faire.com/fastly/2cb07ee59742df5fb886e9dbe02dd85609db1baa5de823339e5b71d48d62c482.jpeg",
    "https://cdn.faire.com/fastly/c9fa34e93f7a338a35366e8df6177382a86d9387ee6eff60f7101f653171a42a.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% deadstock Pima Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:24.947Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
